import { PeopleOwnersAndAdminsState } from 'src/app/PeopleOwnersAndAdmins/redux/peopleOwnersAndAdmins.reducer'
import { RootState } from 'src/redux/createRootReducer'

export const selectPeopleOwnersAndAdmins = (
  state: RootState,
): PeopleOwnersAndAdminsState => state.app.people.peopleOwnersAndAdmins

export const selectPeopleOwnersAndAdminsLoadingFromState = (
  state: RootState,
): boolean => state.app.people.peopleOwnersAndAdmins.loading

export const selectPeopleOwnersAndAdminsRemovingFromState = (
  state: RootState,
): boolean => state.app.people.peopleOwnersAndAdmins.removing

export const selectPeopleOwnersAndAdminsRemoveFailureFromState = (
  state: RootState,
): string | undefined =>
  state.app.people.peopleOwnersAndAdmins.removeFailureTopLevelError

export const selectNumberOfOwnersAndAdminsFromState = (
  state: RootState,
): number => state.app.people.peopleOwnersAndAdmins.totalItems || 0
